import React from 'react';
import { FormDrawer } from './FormDrawer';
import { getActiveChannelOptions } from '../placeholders/commercialCatalogDefaults';

export const LicitationsForm = ({
  isOpen,
  onClose,
  onSave,
  isSaving = false,
  isDarkMode = false,
  isEditing = false,
  formData,
  onChange,
  formError = '',
  channelOptions,
  organizationOptions = [],
  organizationUnitOptions = [],
}) => {
  const channels = Array.isArray(channelOptions) && channelOptions.length > 0
    ? channelOptions
    : getActiveChannelOptions();

  const channelSelectOptions = [
    { value: '', label: 'Sin canal' },
    ...channels,
    ...(formData?.channel && !channels.some((option) => option.value === formData.channel)
      ? [{ value: formData.channel, label: formData.channel }]
      : []),
  ];

  const sections = [
    {
      key: 'general',
      title: 'Datos de licitacion',
      fields: [
        { key: 'licitation_code', label: 'Codigo', placeholder: 'Se asigna automaticamente' },
        { key: 'tender_code', label: 'Codigo externo' },
        { key: 'tender_name', label: 'Nombre' },
        {
          key: 'organization_id',
          label: 'Organizacion',
          type: 'select',
          options: [
            { value: '', label: 'Seleccionar organizacion' },
            ...organizationOptions,
          ],
        },
        {
          key: 'organization_unit_id',
          label: 'Subunidad',
          type: 'select',
          options: [
            { value: '', label: 'Sin subunidad' },
            ...organizationUnitOptions,
          ],
          disabled: !formData?.organization_id,
        },
        {
          key: 'quotation_ids_text',
          label: 'Cotizaciones vinculadas',
          readOnly: true,
          placeholder: 'Se vinculan por el codigo externo',
        },
        { key: 'closing_date', label: 'Fecha de cierre', type: 'date' },
        { key: 'adjudication_date', label: 'Fecha de adjudicacion', type: 'date' },
        { key: 'estimated_amount', label: 'Monto estimado', type: 'number', step: '0.01' },
        { key: 'maximum_amount', label: 'Monto maximo', type: 'number', step: '0.01' },
        { key: 'winning_amount', label: 'Monto ganador', type: 'number', step: '0.01', readOnly: true },
        { key: 'winner', label: 'Ganador', readOnly: true },
        { key: 'currency', label: 'Moneda', type: 'select', options: [
            { value: 'CLP', label: 'CLP' },
            { value: 'USD', label: 'USD' },
            { value: 'EUR', label: 'EUR' },
          ],
        },
        {
          key: 'channel',
          label: 'Canal',
          type: 'select',
          options: channelSelectOptions,
        },
        { key: 'assigned_user', label: 'Responsable' },
        {
          key: 'status',
          label: 'Estado',
          type: 'select',
          options: [
            { value: 'Abierta', label: 'Abierta' },
            { value: 'En Analisis', label: 'En Analisis' },
            { value: 'Oferta Enviada', label: 'Oferta Enviada' },
            { value: 'Adjudicada', label: 'Adjudicada' },
            { value: 'Perdida', label: 'Perdida' },
            { value: 'Cancelada', label: 'Cancelada' },
          ],
        },
        { key: 'notes', label: 'Notas', fullWidth: true },
      ],
    },
  ];

  return (
    <FormDrawer
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      isSaving={isSaving}
      isDarkMode={isDarkMode}
      title={isEditing ? 'Editar Licitacion' : 'Agregar Licitacion'}
      subtitle="Formulario de licitaciones"
      sections={sections}
      formData={formData}
      onChange={onChange}
      formError={formError}
      width={560}
    />
  );
};

export default LicitationsForm;
